import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "upgrade"
    }}>{`Upgrade`}</h1>
    <h2 {...{
      "id": "how-to-update-the-seasonal-pricing-plugin-to-the-latest-version"
    }}>{`How to update the Seasonal Pricing plugin to the latest version?`}</h2>
    <pre><code parentName="pre" {...{}}>{`1. Download the latest package/plugin from codeCanyon.
2. Go to your cPanel file manager
3. Then go to you WordPress site directory
4. Then wp-content/plugins
5. Then delete the Seasonal Pricing plugin folder
6. Upload and extract the downloaded new plugin
7. Refresh your dashboard
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      